import React, { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import Tooltip from '@cld/tooltip';
import { SliderProps } from '../props';

export const withTooltip = (Comp: ForwardRefExoticComponent<RefAttributes<unknown>>) =>
  forwardRef(({ showTooltip, tooltipPlacement, value, ...props }: SliderProps, ref) =>
    showTooltip ? (
      <Tooltip trigger="hover" title={value} placement={tooltipPlacement}>
        <Comp {...props} ref={ref} />
      </Tooltip>
    ) : (
      <Comp {...props} ref={ref} />
    )
  );
